export default __webpack_public_path__ + "static/katherine_rundell-be6186bf6f9d36882e7274849d1204e2.jpg";